"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeedModalBody = NeedModalBody;
const react_1 = __importStar(require("react"));
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../../View/Modals/FormContext");
const FinancialAidProgrammesController_1 = require("../../FinancialAidProgrammesController");
const StatusSelectors_1 = require("../../../View/Modals/CommonFormComponents/StatusSelectors");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
const InlineCreateDrawers_1 = require("../../../View/Modals/InlineCreateDrawers");
function NeedModalBody({ isEditing, initialData }) {
    const { register, reset, setValue, formState: { errors }, trigger, watch, } = (0, FormContext_1.useFormContext)();
    (0, react_1.useEffect)(() => {
        const resetData = {
            _client: initialData?._client,
            name: initialData?.name,
            description: initialData?.description,
            status: initialData?.status,
            _focusAreas: initialData?._focusAreas,
            _applicationCall: initialData?._applicationCall || null,
        };
        reset(resetData);
        trigger();
    }, [initialData, reset, trigger]);
    (0, react_1.useEffect)(() => {
        console.log("Application call changed", watch("_applicationCall"));
    }, [watch("_applicationCall")]);
    const _focusAreas = watch("_focusAreas");
    const [showCreateClient, setShowCreateClient] = (0, react_1.useState)(false);
    const [showCreateFocusArea, setShowCreateFocusArea] = (0, react_1.useState)(false);
    function handleFocusAreaCreated(created) {
        const current = (_focusAreas) || [];
        setValue("_focusAreas", [...current, created], { shouldValidate: true });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Klient"),
            react_1.default.createElement(BussinesObjectSelectors_1.EntitySelector, { name: "_client", repository: FinancialAidProgrammesController_1.clientsRepository, multiple: false, showValidationInfo: true, onRequestCreate: () => setShowCreateClient(true) })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "name" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nazwa"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", placeholder: "Podaj nazw\u0119", isValid: !errors?.name, isInvalid: !!errors?.name, ...register("name") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "name", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "description" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Opis"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 3, placeholder: "Podaj opis", isValid: !errors?.description, isInvalid: !!errors?.description, ...register("description") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "description", errors: errors })),
        react_1.default.createElement(StatusSelectors_1.ClientNeedStatusSelector, null),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "_focusAreas" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Przypisz dzia\u0142ania"),
            react_1.default.createElement(BussinesObjectSelectors_1.FocusAreaSelector, { name: "_focusAreas", multiple: true, onRequestCreate: () => setShowCreateFocusArea(true) })),
        _focusAreas && (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "_applicationCall" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Wybierz nabor"),
            react_1.default.createElement(BussinesObjectSelectors_1.ApplicationCallSelector, { name: "_applicationCall", multiple: false, _focusArea: _focusAreas }))),
        react_1.default.createElement(InlineCreateDrawers_1.EntityInlineCreateDrawer, { show: showCreateClient, onHide: () => setShowCreateClient(false), title: "Nowy klient", repository: FinancialAidProgrammesController_1.clientsRepository, onCreated: (created) => setValue("_client", created, { shouldValidate: true }) }),
        react_1.default.createElement(InlineCreateDrawers_1.FocusAreaInlineCreateDrawer, { show: showCreateFocusArea, onHide: () => setShowCreateFocusArea(false), title: "Nowe dzia\u0142anie", onCreated: handleFocusAreaCreated })));
}
